/*=========================================================================================
  File Name: moduleContext.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
==========================================================================================*/

import state from './moduleContextState';
import mutations from './moduleContextMutations';
import actions from './moduleContextActions';
import getters from './moduleContextGetters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state: state,
	mutations: mutations,
	actions: actions,
	getters: getters
};
